import type { GroupClient } from '#src/groups/http/group_client.ts';
import type { GetGroupResponse } from '@packages/contracts/group';
import { Duration } from '@packages/primitives/duration';
import { exists } from '@packages/primitives/exists';
import { invariant } from '@packages/primitives/invariant';
import { useQuery } from '@tanstack/react-query';

export function getGroupQueryKey(groupId: string | undefined) {
  return ['group', groupId] as const;
}

export function useGetGroup(groupClient: GroupClient, groupId: string | undefined) {
  const query = useQuery<GetGroupResponse, Error>({
    enabled: exists(groupId),
    queryKey: getGroupQueryKey(groupId),
    queryFn: () => {
      invariant(exists(groupId), 'Expected an enabled group query to have an id.');
      return groupClient.getGroup({ groupId });
    },
    staleTime: Duration.ofMinutes(2),
    gcTime: Duration.ofMinutes(10),
    retry: false,
  });

  return {
    isPending: query.isPending,
    result: query.data,
    httpError: query.error,
  };
}
